import { render, staticRenderFns } from "./ModernTipoEtapaProdutividadeSelect.vue?vue&type=template&id=b7072ca0&"
import script from "./ModernTipoEtapaProdutividadeSelect.vue?vue&type=script&lang=js&"
export * from "./ModernTipoEtapaProdutividadeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports